import { render, staticRenderFns } from "./Street.vue?vue&type=template&id=c45a2d4e&"
import script from "./Street.vue?vue&type=script&lang=js&"
export * from "./Street.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports